import script from "./SentSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SentSuccess.vue?vue&type=script&setup=true&lang=js"

import "./SentSuccess.vue?vue&type=style&index=0&id=49b1cde5&lang=css"

const __exports__ = script;

export default __exports__